export class ApiRequest{
	stringJson: string;
	userAgent: string;
	authtoken: string;
}